export default __webpack_public_path__ + "static/media/mailbox-bb5582fb74c801bfef773921c0410570.png";